export const columnNameAdmin = {
  path: 'name',
  link: '/referrals/:_id',
};

export const columnNameSellerMerchant = {
  path: 'name',
  link: '/store/referrals/:_id',
};

export const columnNameSellerReferral = {
  path: 'name',
  link: '/store/partners/referrals/:_id',
};

export const columnStore = {
  title: 'Store',
  path: 'store.name',
  link: '/stores/:store._id',
};

export const columnReferralStore = {
  title: 'Referral Store',
  path: 'referralStore.name',
  link: '/stores/:referralStore._id',
};

export const columnStoreName = {
  title: 'Partner',
  path: 'store.name',
};

export const columnReferralStoreName = {
  title: 'Partner',
  path: 'referralStore.name',
};

export const ADMIN = [
  columnNameAdmin,
  columnStore,
  columnReferralStore,
];

export const SELLER_MERCHANT = [
  columnNameSellerMerchant,
  columnReferralStoreName,
];

export const SELLER_REFERRAL = [
  columnNameSellerReferral,
  columnStoreName,
];
